module.exports = __webpack_public_path__ + "img/icon-school.cfce08ed.svg";